import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { ScrollContainer } from '../../scroll-container/ScrollContainer';
import styles from './ModalBody.module.scss';

export const ModalBody = ({ children, className, height = '45vh' }: Props) => (
    <div className={classNames(className, styles.body)}>
        <ScrollContainer maxHeight={height} className={styles.scrollContainer}>
            {children}
        </ScrollContainer>
    </div>
);

type Props = PropsWithChildren<{
    height?: number | string;
    className?: string;
}>;